import { Link } from "react-router-dom";

/**
 * Top Employers carousel/grid — CLS-safe, no external logos.
 * Uses fixed-height tiles with company initials + brand colors → zero layout
 * shift (LCP-safe) and no copyright risk. Passes an explicit `data-testid`
 * for e2e checks.
 */
export default function TopEmployers({ companies = [], limit = 12 }) {
  const list = companies.slice(0, limit);
  if (!list.length) return null;
  return (
    <section className="my-8" aria-labelledby="top-employers-h2" data-testid="top-employers">
      <div className="flex items-end justify-between mb-4">
        <div>
          <div className="text-xs uppercase tracking-wider font-bold text-orange-600">Corporate India</div>
          <h2 id="top-employers-h2" className="text-2xl md:text-3xl font-extrabold mt-1" style={{ fontFamily: "'Cabinet Grotesk',sans-serif" }}>
            Top Employers Hiring Now
          </h2>
        </div>
        <Link
          to="/private-jobs"
          data-testid="top-employers-view-all"
          className="text-sm font-semibold text-slate-700 hover:text-orange-600 hidden sm:inline-flex items-center gap-1"
        >
          View all →
        </Link>
      </div>
      <ul
        className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3"
        role="list"
      >
        {list.map((c) => (
          <li key={c.slug} className="min-h-[96px]">
            <Link
              to={`/private-jobs/${c.slug}`}
              data-testid={`employer-tile-${c.slug}`}
              className="block h-24 w-full rounded-lg px-3 py-3 text-center font-extrabold text-base leading-tight hover:opacity-95 transition-opacity flex flex-col items-center justify-center"
              style={{
                background: c.brand_bg || "#0f172a",
                color: c.brand_color || "#ffffff",
                fontFamily: "'Cabinet Grotesk', sans-serif",
              }}
              aria-label={`${c.name} — ${c.active_jobs || 0} open jobs`}
            >
              <span className="truncate max-w-full">{c.short_name || c.name}</span>
              <span className="mt-1 text-[11px] font-medium opacity-90">
                {c.active_jobs || 0} open
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
